import { render, staticRenderFns } from "./ExportXlsx.vue?vue&type=template&id=22ce9547&"
import script from "./ExportXlsx.vue?vue&type=script&lang=js&"
export * from "./ExportXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports